import { Message } from 'element-gui';
import service from '@/request/service';
import { getOverAllButtonPermission } from '@/api/objection';

const state = {
  failBidInfo: [],
  tendCtrlPriceObj: {},
  dissentRightObj: {},
  openBondMsg: '',
  batchFailBidList: [],
};

const getters = {
  getTendCtrlPriceObj: (state) => state.tendCtrlPriceObj,
  getDissentRight: (state) => state.dissentRightObj,
};

const actions = {
  getFailBidInfo({ commit }, obj) {
    service.get('/openBid/info/getOpenbidStage', {
      params: {
        domainId: sessionStorage.getItem('row') &&
            JSON.parse(sessionStorage.getItem('row'))[0].domainId,
      },
    }).then(({data, code, msg}) => {
      if (code === 200) {
        service.post('/failBid/getFailBidInfo', {
          domainID:
              sessionStorage.getItem('row') &&
              JSON.parse(sessionStorage.getItem('row'))[0].domainId,
          openBidStage: data,
          roleType: JSON.parse(sessionStorage.getItem('obj')).userType,
          userCode: JSON.parse(sessionStorage.getItem('obj')).userId,
          failBidNode: obj.failBidNode
          // failBidNode:
          // bidCountDown:
          // decryptEnd:
          // secondBidOpen:
          // effectiveBidderConts:
        }).then(({code, msg, data}) => {
          if (code === 200) {
            commit('FAILBIDINFO', data);
          } else {
            Message({message: msg, type: 'error'});
          }
        });
      }
    })
  },
  getTendCtrlPriceInfo({ commit }, obj) {
    commit('TENDCTRLPRICEINFO', obj);
  },
  setBatchFailBid({ commit }, obj) {
    commit('BATCHFAILBID', obj);
  },
  // 异议权限
  setDissentRight({ commit }, obj) {
    getOverAllButtonPermission({
      domainId: obj.domainId,
      stage: obj.stage,
    }).then((res) => {
      if (res.code == 200) {
        commit('GETDISSENTRIGHT', res.data);
      } else {
        Message({
          message: res.msg,
          type: 'error',
        });
      }
    });
  },
};

const mutations = {
  FAILBIDINFO(state, payload) {
    state.failBidInfo = payload;
  },
  TENDCTRLPRICEINFO(state, payload) {
    state.tendCtrlPriceObj = payload;
  },
  GETDISSENTRIGHT(state, payload) {
    state.dissentRightObj = payload;
  },
  OPENBONDMSG(stat, payload) {
    state.openBondMsg = payload;
  },
  BATCHFAILBID(state, payload) {
    state.batchFailBidList = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
